import * as React from "react";
import {
	BrowserRouter as Router,
	Switch,
	Route,
	useParams,
	HashRouter,
	useRouteMatch,
} from "react-router-dom";
import SuccessAuth from "./Pages/SuccessAuth/SuccessAuth";
import BookPage from "./BookPage/BookPage";
import ProfilePage from "./Pages/Profile/Profile";
import CalendarPage from "./Pages/Calendar/CalendarPage";
import LoginPage from "./Pages/Login/LoginPage";
import MyBooks from "./Pages/MyBooks/MyBooks";
import getIndex from "../requests/getIndex";
import { connect, useSelector } from "react-redux";
import { addCollectionsAction } from "../store/collections/actions";
import { getUserProfile } from "../store/user/selectors";
import { setCurrentUserAction } from "../store/user/actions";
import CardsManager from "./CardsManager/CardsManager";
import { Config } from "..";
import Footer from "./Footer/Footer";
import MediaQuery from "react-responsive";
import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH } from "../utils";
import Collections from "./Collections/Collections";
import Feed from "./Feed/Feed";
import List from "./Pages/List/List";
import BookForm from "./Pages/BookForm/BookForm";
import getUserInfo from "../requests/getUserInfo";

interface OwnProps {
	config: Config;
}

interface DispathProps {
	addCollections: typeof addCollectionsAction;
	setUser: typeof setCurrentUserAction;
}

const Component: React.FunctionComponent<OwnProps & DispathProps> = (props) => {
	const userProfile = useSelector(getUserProfile);

	// const firebase = useMessageFirebase(userProfile?.id);

	React.useEffect(() => {
		const request = async () => {
			const data = await getUserInfo();

			if (data && data.id) {
				props.setUser({
					userId: data.id,
					user: {
						...data,
					},
				});

				localStorage.setItem(
					"userProfile",
					JSON.stringify({
						...data,
					})
				);
			} else {
				props.setUser({
					userId: -2,
					user: null,
				});
			}
		};

		request();
	}, []);

	const indexPage = useRouteMatch("/");

	return (
		<>
			<Route route="/">
				<MediaQuery maxWidth={TABLET_MAX_WIDTH}>
					<Footer />
				</MediaQuery>
			</Route>

			<Switch>
				<Route path="/books">
					<HashRouter>
						<MyBooks />
					</HashRouter>
				</Route>

				<Route path="/book">
					<HashRouter>
						<Route path="/:id">
							<CardsManager withoutInitial={true}>
								{(callbacks) => {
									return <BookPage callbacks={callbacks} />;
								}}
							</CardsManager>
						</Route>
					</HashRouter>
				</Route>

				<Route path="/collections">
					<HashRouter>
						<CardsManager>
							{(callbacks) => {
								return <Collections callbacks={callbacks} />;
							}}
						</CardsManager>
					</HashRouter>
				</Route>

				<Route path="/calendar">
					<HashRouter>
						<CalendarPage />
					</HashRouter>
				</Route>

				<Route path="/profile">
					<HashRouter>
						<ProfilePage />
					</HashRouter>
				</Route>

				<Route path="/successauth">
					<SuccessAuth />
				</Route>

				<Route path="/login">
					<LoginPage />
				</Route>

				<Route path="/book-form">
					<BookForm />
				</Route>

				<Route path="/list">
					<CardsManager withoutInitial={true}>
						{(callbacks) => <List callbacks={callbacks} />}
					</CardsManager>
				</Route>

				<Route route="/" exact={true}>
					{indexPage.isExact && (
						<CardsManager withoutInitial={true}>
							{(callbacks) => (
								<HashRouter>
									<Feed callbacks={callbacks} limit={15} />
								</HashRouter>
							)}
						</CardsManager>
					)}
				</Route>
			</Switch>
		</>
	);
};

export default connect(() => {}, {
	addCollections: addCollectionsAction,
	setUser: setCurrentUserAction,
})(Component);
